import React from 'react'
import clsx from 'clsx'
import { Signpost } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Dropdown from '@SonarCX/components/atoms/Dropdown'
import TaskStatus from '@SonarCX/components/molecules/RenderOptions/TaskStatus'

const StatusSection = ({
  classes,
  statuses,
  handleChange,
  values,
  canComplete,
  canEdit
}) => {
  const theme = useTheme()
  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        classes.container
      )}
    >
      <span className={clsx(classes.center, classes.label)}>
        <Signpost size={theme.size.base} variant='Bulk' color='#B64FCD' />{' '}
        STATUS
      </span>

      <Dropdown
        options={statuses.map(({ id }) => id)}
        disabledOptions={statuses
          .map(({ id, base_status, name }) => {
            if (canComplete) {
              return null
            }

            return base_status === 'completed' ? id : null
          })
          .filter(Boolean)}
        renderOption={id => {
          const opt = statuses.find(s => s.id === id)

          if (opt) {
            return <TaskStatus key={id} opt={opt} />
          }
          return null
        }}
        selected={values.status}
        onSelect={id => handleChange('status')({ target: { value: id } })}
        hideAdd
        colour
        disabled={!canEdit}
      >
        <div className={classes.center}>
          <TaskStatus
            opt={statuses.find(({ id }) => id === values.status) ?? []}
          />
        </div>
      </Dropdown>
    </div>
  )
}
export default StatusSection
